import axios from '../utils/axios/index.js';

export const fetchOrderCenterDetails = () => {
  return axios.get('/api/ordercenter/details');
}

export const fetchOrderCenterFee = () => {
  return axios.get('/api/ordercenter/fee');
}

export const fetchOrderCenterAssociation = () => {
  return axios.get('/api/ordercenter/association');
}



// WEBPACK FOOTER //
// ./src/api/order-center.js